module.exports = __webpack_public_path__ + "media/organizations/tu-berlin-7a2f15bb.svg";